var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCarouselPool = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0V0z",
    id: "w30d2ti3la"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#w30d2ti3la"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3C677A",
    fillRule: "nonzero",
    d: "m1 30.496 20.63 12.052 31.89-18.28L32.614 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9AB6BF",
    fillRule: "nonzero",
    d: "m7.625 34.4 25.17-14.982 14.564 8.418-25.715 14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.414 30.438c.016-1.67.03-3.34-.025-5.01a36.622 36.622 0 0 0-.055-1.203c-.023-.344-.07-.7-.24-1.004a1.052 1.052 0 0 0-.712-.528c-.302-.056-.603.038-.78.303-.106.158-.144.35-.167.537-.025.212-.033.428-.043.642-.022.467-.024.935-.008 1.404.006.194.307.195.3 0a17.952 17.952 0 0 1 .028-1.762c.01-.152.017-.305.055-.452.033-.124.091-.251.2-.321a.452.452 0 0 1 .298-.063c.239.022.45.182.569.393.152.272.183.595.203.901.024.385.038.77.051 1.154.027.785.037 1.57.04 2.354.002.885-.006 1.77-.015 2.656-.001.195.299.195.3 0h.001zM11.384 29.085c.016-1.669.03-3.34-.025-5.009-.014-.401-.028-.803-.055-1.204-.023-.344-.07-.699-.24-1.004a1.052 1.052 0 0 0-.711-.528c-.303-.056-.604.038-.781.303-.106.158-.144.35-.166.537-.026.213-.034.428-.044.642-.022.467-.024.936-.008 1.404.007.194.307.195.3 0a17.952 17.952 0 0 1 .028-1.762c.01-.151.017-.305.055-.452.033-.124.091-.251.2-.321a.452.452 0 0 1 .299-.063c.238.022.45.182.568.393.152.272.184.595.203.902.024.384.038.77.051 1.154.027.784.038 1.568.04 2.353.002.885-.006 1.77-.014 2.656-.002.195.298.195.3 0z",
    fill: "#E8C77C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E8C77C",
    strokeWidth: 0.3,
    d: "m11.175 24.873-1.89 1.23M11.188 26.34l-1.89 1.228M11.234 27.866l-1.888 1.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9AB6BF",
    fillRule: "nonzero",
    d: "m42.662 28.52 5.13-3.368 2.175 2.747-6.998 2.198z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9AB6BF",
    fillRule: "nonzero",
    d: "M21.6 42.702 28.824 47l24.933-16.357-9.755-4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C677A",
    fillRule: "nonzero",
    d: "m32.84 19.33-.304-7.275 20.87 12.273-6.06 3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9EBF2",
    fillRule: "nonzero",
    d: "m47.182 16.067-2.247-1.164-.327.213 1.58 1.428.1.238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272C61",
    fillRule: "nonzero",
    d: "m43.76 17.538 1.754.981-.08-2.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F94AE",
    fillRule: "nonzero",
    d: "m45.428 16.484.08 2.035 1.742-1.013-.068-1.44-.821.5-.027-.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m37.461 19.095 1.809 1.004 7.06-4.409-1.922-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C0C5D9",
    fillRule: "nonzero",
    d: "m37.46 19.108.01.277 1.796.954 7.073-4.408-.01-.241-7.062 4.352z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C677A",
    fillRule: "nonzero",
    d: "m53.78 24.47.195.108L59 27.374l-5.993 3.84-4.743-2.832-.8-.478M47.347 27.828l.146.101"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C677A",
    fillRule: "nonzero",
    d: "M53.465 24.235 59 27.375l-11.422.597-.315-.2"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCarouselPool);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-carousel-pool.cdfc07bb7650b2af55cab18c653c2bd0.svg";